/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Workspace_TitleInputs */

const en_dashboard_workspace_title = /** @type {(inputs: Dashboard_Workspace_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Personal Task Workspace`)
};

const pt_br2_dashboard_workspace_title = /** @type {(inputs: Dashboard_Workspace_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu Espaço de Trabalho`)
};

/**
* | output |
* | --- |
* | "My Personal Task Workspace" |
*
* @param {Dashboard_Workspace_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_workspace_title = /** @type {((inputs?: Dashboard_Workspace_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Workspace_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_workspace_title(inputs)
	return pt_br2_dashboard_workspace_title(inputs)
});